import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { LAYOUT_DIMENSIONS } from '../hooks/useResponsiveLayout'

interface DeviceFABProps {
  onClick: () => void
  deviceCount?: number
  showBottomTabs?: boolean
}

export function DeviceFAB({ onClick, showBottomTabs = false }: DeviceFABProps) {
  // Position just above Google logo / bottom tabs
  const bottomOffset = showBottomTabs ? LAYOUT_DIMENSIONS.BOTTOM_TAB_HEIGHT + 4 : 24

  return (
    <button
      onClick={onClick}
      className="fixed left-0 z-40 flex items-center justify-center bg-white hover:bg-gray-50 active:bg-gray-100 text-gray-600 shadow transition-colors touch-manipulation rounded-r"
      style={{
        width: 28,
        height: 48,
        bottom: bottomOffset,
      }}
      aria-label="Open device list"
    >
      <FontAwesomeIcon icon={faChevronRight} className="text-base" />
    </button>
  )
}
